import React from 'react';
import styled from 'styled-components';

import Error from 'app/ui/components/atoms/error';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 90vh;
  gap: 2rem;
  justify-content: center;
  align-items: center;
  padding: 0 ${({ theme }) => theme.spacing(9)};
`;

const ErrorMolecule: React.FC = () => (
  <Wrapper>
    <Error />
  </Wrapper>
);

export default ErrorMolecule;
